import React from "react";

const ResetButton = ({ onClick }) => {
  return (
    <button className="a11y-reset" onClick={onClick}>
      Reset All Settings
    </button>
  );
};

export default ResetButton;
